import { AnyAction } from 'redux';

import { stationsActions } from '../reducer';

import { MarkerServicePriceStation, PriceServiceMapData } from '../../types';

export const updateMarkerPriceServiceStations = (markerServicePriceStation: MarkerServicePriceStation[]): AnyAction =>
  stationsActions.setMarkerServiceStations(markerServicePriceStation);

export const updatePricesServiceMapData = (priceServiceMapData: Array<PriceServiceMapData[]>): AnyAction =>
  stationsActions.setPricesServiceMapData(priceServiceMapData);
